var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconApartmentHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5957 13.2701L16.7912 14.143L11.9747 18L7.14835 14.143C6.77759 13.7352 5.69087 12.3723 5.49594 11.8307C5.30101 11.2892 5.2074 10.7079 5.22103 10.1234C5.23465 9.53901 5.3552 8.96409 5.57509 8.43489C5.79498 7.90569 6.10944 7.43367 6.49868 7.04857C6.88791 6.66346 7.34349 6.37361 7.83672 6.19725C8.32995 6.0209 8.85014 5.96188 9.36455 6.02389C9.87895 6.08591 10.3764 6.26762 10.8256 6.55759C11.2748 6.84755 11.6612 7.24516 11.9698 7.71439C12.2797 7.24856 12.6763 6.85439 13.1252 6.5675C13.5741 6.28061 14.0705 6.10152 14.5835 6.04144C15.0965 5.98136 15.6149 6.04159 16.1063 6.21835C16.5977 6.39512 17.0516 6.68461 17.4394 7.06871C17.8273 7.45281 18.1408 7.92326 18.3604 8.4506C18.58 8.97795 18.7009 9.55084 18.7156 10.1334C18.7303 10.716 18.6384 11.2957 18.4456 11.8363C18.2529 12.3769 17.9636 12.8668 17.5957 13.2752",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApartmentHeart);
export default __webpack_public_path__ + "static/media/icon_apartment_heart.f7b98b6cfa667f6903ae648663346dbf.svg";
export { ForwardRef as ReactComponent };